<div class="panel-inferior">
  <div class="barra-accion-principal" (click)="togglePanel()">
    <div class="bloque-accion-izq">
      <div class="icono-carrito-accion">
        <i class="fa-solid fa-cart-shopping"></i>
      </div>
      <div>
        <h2 class="titulo-accion">Resumen compra</h2>
        <span class="subtitulo-accion">
          {{ productos?.length || 0 }} productos<span class="ms-1 me-1">·</span><span>{{ getProductosCheck("X").length == 0 ? 'Ninguno' : getProductosCheck("X").length }} en la cesta</span>
        </span>
      </div>
    </div>

    <div
      class="flecha-desplegable"
      [style.transform]="panelAbierto ? 'rotate(180deg)' : 'rotate(0deg)'"
      style="transition: transform 0.3s ease">
      <i class="fa-solid fa-chevron-up"></i>
    </div>
  </div>

  <div
    class="contenido-detallado-panel"
    [@slideInOut]="panelAbierto ? 'abierto' : 'cerrado'"
  >
    <div class="contenedor-progreso-accion">
      <div class="columna-progreso">
        <div class="cabecera-progreso">
          <!--<span class="etiqueta-progreso">Progreso</span>-->
          <span class="porcentaje-progreso">{{ getProgresoCompra() }}%</span>
        </div>
        <div
          class="progress"
          role="progressbar"
          aria-label="Progreso compra"
          aria-valuenow="25"
          aria-valuemin="0"
          aria-valuemax="100"
        >
          <div
            class="progress-bar bg-success"
            [style.width.%]="getProgresoCompra()"
          ></div>
        </div>
      </div>
      
      <div class="columna-boton">
        <button type="button" title="Deshacer última acción"
          [class.boton-undo]="productos_historial?.length == 0"
          [class.boton-anadir]="productos_historial?.length > 0"
          (click)="undoAccion()"><i class="fa-solid fa-rotate-left"></i></button>
      </div>

      <div class="columna-boton">
        <button
          class="boton-finalizar-accion"
          (click)="finalizarCompra()"
          *ngIf="!formFinalizar"
        >
          Finalizar compra
        </button>
      </div>
    </div>

    <div class="bloques-resumen-contenedor" *ngIf="!formFinalizar">
      <div class="tarjeta-resumen productos pointer" (click)="verCompras()">
        <span class="encabezado-tarjeta-resumen"
          ><i class="fa-solid fa-arrow-trend-down"></i> Última compra</span>
        <span class="fw-bold text-capitalize">{{ totales.ultimacompra.li_fechahora | cuandoFechas }}</span>
        <div class="valor-total-resumen">{{totales.ultimacompra.li_total | currency:'EUR':'symbol':'1.2-2':'es-ES'}}</div>
        <div class="ms-1 subtexto-resumen">{{totales.ultimacompra.li_obs}}</div>
      </div>
      <div class="tarjeta-resumen mes pointer" (click)="verCompras()">
        <span class="encabezado-tarjeta-resumen"><i class="fa-regular fa-calendar"></i> Mensual</span>
        <span class="valor-resumen text-capitalize">{{ fechaActual | date:'MMMM y' }}</span>
        <span class="valor-total-resumen">{{totales.totalmes.total | currency:'EUR':'symbol':'1.2-2':'es-ES'}}</span>
        <!--<span class="ms-1 subtexto-resumen">{{totales.totalmes.compras}} compras</span>-->
        <div>
          <span class="text-danger" *ngIf="totales.totalmes.diferencia > 0">{{totales.totalmes.diferencia | abs | currency:'EUR':'symbol':'1.2-2':'es-ES'}} más</span>
          <span class="text-success" *ngIf="totales.totalmes.diferencia <= 0">{{totales.totalmes.diferencia | abs | currency:'EUR':'symbol':'1.2-2':'es-ES'}} menos</span>
        </div>
        <span class="valor-resumen-anterior">{{totales.totalmesanterior.aniomes | periodoFecha}}</span>
        <span class="valor-total-resumen-anterior">{{totales.totalmesanterior.total | currency:'EUR':'symbol':'1.2-2':'es-ES'}}</span>
      </div>
    </div>

    <div class="bloques-resumen-contenedor" *ngIf="formFinalizar">
      <div class="tarjeta-resumen mes">
        <div>
          <span class="encabezado-tarjeta-resumen">Importe total</span>
          <input type="number" class="form-control" [(ngModel)]="inputsFinalizar.li_total" step="0.1" placeholder="0.00"/>
        </div>
        <div>
          <span class="encabezado-tarjeta-resumen">Lugar, establecimiento</span>
          <input type="text" class="form-control" [(ngModel)]="inputsFinalizar.li_obs" />
        </div>
        <div class="mt-2">
          <div class="row">
            <div class="col">
              <button type="button" class="boton-finalizar-accion" (click)="finalizar()">
                Finalizar
              </button>
            </div>
            <div class="col">
              <button
                type="button"
                class="boton-cancelar-accion"
                (click)="finalizarCompra()"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--PARTICIPANTES-->
    <div class="seccion-participantes">
      <div class="titulo-participantes">Participantes</div>

      <div class="fila-participante" *ngFor="let participante of participantes">
        <div class="info-participante-izq text-nowrap">
          <div style="position: relative">
            <div *ngIf="participante.foto == ''" class="avatar-texto" [style.background-color]="participante.pr_color_brand">{{participante.pr_first_brand}}</div>
            <img *ngIf="participante.foto != ''" class="avatar-usuario" [src]="participante.foto" style="width: 50px!important;height: 50px!important;">
            <span class="punto-conectado" *ngIf="participante.online"></span>
          </div>
          <div>
            <div class="nombre-participante">
              {{ participante.first_name }}
            </div>
            <div class="cantidad-productos-participante">{{getProductosUsuario(participante.ID ).length}} productos</div>
          </div>
        </div>
        <div class="text-end tiempo-actividad-participante">{{participante.last_activity | cuandoFechas}}</div>
      </div>
    </div>
  </div>
</div>
